
import('leaflet').then(({ default: L }) => {
  const map = L.map('map').setView([30, 10], 2);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors',
    maxZoom: 18
  }).addTo(map);
  const cities = [
    [37.7749, -122.4194, 'San Francisco', 182],
    [51.5074, -0.1278,   'London',        147],
    [52.5200, 13.4050,   'Berlin',         98],
    [35.6762, 139.6503,  'Tokyo',          76],
    [-23.5505, -46.6333, 'São Paulo',      52],
    [56.9496, 24.1052,   'Riga',           31]
  ];
  cities.forEach(([lat, lng, name, count]) => {
    L.circleMarker([lat, lng], {
      radius: Math.max(6, Math.sqrt(count) * 1.5),
      color: '#1ABB9C', fillColor: '#1ABB9C', fillOpacity: 0.4, weight: 2
    }).addTo(map).bindPopup(`<strong>${name}</strong><br>${count} customers`);
  });
});
